<button #ref *ngIf="authenticated" [disabled]="loading" [className]="className" (click)="logout($event)" >
	<ng-content></ng-content>
	<span *ngIf="ref.childNodes.length == 0">
		{{ 'Sign Out' | translate }}
	</span>
</button>

